import { put, call, takeLatest } from 'redux-saga/effects';
// components
import { modalRoutine } from '../../modal/routines';
// constants
import * as C from '../../../constants';
// utilities
import { ENDPOINTS } from '../../../utilities/http/endpoints';
import {
  getFormData,
  sendRequest,
  handleException,
  showToastrMessage,
  isResponseSuccess,
  handleFailResponse,
  calculatePercentage,
} from '../../../utilities';
// app-layout
import { headerRoutine, headerFileUploadStatusData } from './routines';
//////////////////////////////////////////////////

function* handleCheckFileUploadStatus() {
  try {
    const res = yield call(sendRequest, 'get', ENDPOINTS.checkFileStatus);

    const { data, error, status } = res;

    const {
      endTime,
      fileName,
      startTime,
      totalRecords,
      processedStatus,
      processedRecords,
    } = data;

    if (isResponseSuccess(status)) {
      yield put(headerFileUploadStatusData.success({
        fileName,
        processedStatus,
        processedEndDate: endTime,
        processedStartDate: startTime,
        processedOn: calculatePercentage(totalRecords, processedRecords),
      }));
    } else {
      yield call(showToastrMessage, 'error', error);
      yield call(handleFailResponse, res, 'handleCheckFileUploadStatus fail', true);

      yield put(headerFileUploadStatusData.failure());
    }
  } catch (error) {
    yield call(showToastrMessage, 'error', error.message);
    yield call(handleException, error, 'handleCheckFileUploadStatus exception');
  }
}

function* handleFileUpload({ payload }) {
  try {
    const body = getFormData(payload);

    yield call(sendRequest, 'post', ENDPOINTS.importFile, {
      body,
      headers: {
        [C.CONTENT_TYPE]: C.MULTIPART_FORM_DATA,
      },
    });

    yield put(modalRoutine(false));
  } catch (error) {
    yield call(showToastrMessage, 'error', error.message);
    yield call(handleException, error, 'handleFileUpload exception');
  }
}

export default function* fileUploadWatcherSaga() {
  yield takeLatest(headerRoutine.upload, handleFileUpload);
  yield takeLatest(headerFileUploadStatusData, handleCheckFileUploadStatus);
}

export {
  handleFileUpload,
  handleCheckFileUploadStatus,
};
